import { React, useEffect, useState }  from "react";
import "./JobDescription.css";
import axios from "../../api/axios";

const JobDescription = () => {
    const params = new URLSearchParams(window.location.pathname);
    const n = params.toString().lastIndexOf('%2F');
    const id = params.toString().substring(n + 3).slice(0, -1);
    const [job, setJob] = useState({});
    const [submit, setSubmit] = useState();
    const [disableInputs, setDisableInputs] = useState(false);
    const [submitted, setSubmitted] = useState();
    const [resMessage, setResMessage] = useState('Thank you for applying to V3!');

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [resume, setResume] = useState();
    const [optIn, setOptIn] = useState();

    const [errorF, setErrorF] = useState();
    const [errorL, setErrorL] = useState();
    const [errorE, setErrorE] = useState();
    const [errorP, setErrorP] = useState();
    const [errorR, setErrorR] = useState();
    const [errorO, setErrorO] = useState();


    useEffect(() => {
        window.scrollTo(0, 0)
        const getJobInfo = async () => {
            try {
                const response = await axios.get('/listings/' + id);
                const data = response.data;
                console.log(data)
                setJob(data);
            } catch(err) {
                console.log(err);
            }   
        }

        getJobInfo();
    }, [id]);

    const errorCheck = () => {
        let hasError = false;
        setErrorF(false);
        setErrorL(false);
        setErrorE(false);
        setErrorP(false);
        setErrorR(false);
        setErrorO(false);

        if (!firstName.trim()) {
            setErrorF(true);
            hasError = true;
        }

        if (!lastName.trim()) {
            setErrorL(true);
            hasError = true;
        }

        if (!email.trim() || !/^\S+@\S+\.\S+$/i.test(email)) {
            setErrorE(true);
            hasError = true;
        }

        if (!phone.trim() || !/^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i.test(phone)) {
            setErrorP(true);
            hasError = true;
        }

        if (!resume) {
            setErrorR(true);
            hasError = true;
        }

        if (!optIn) {
            setErrorO(true);
            hasError = true;
        }

        if(hasError === false){
            submitApp();
        }
    }

    const submitApp = async () => {
        setSubmit(true);
        setDisableInputs(true);
        let jobInfo = 'Role: ' + job.role + 
            '\nLocation: ' + job.location +
            '\nDepartment: ' + job.department;

        let currentDate = new Date().toJSON().slice(0, 10);
            
        const payload = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Phone: phone,
            Job_Information__c: jobInfo,
            Date_Applied__c: currentDate
        }
        try {
            const lead = await axios.post('/submit', payload);

            if(lead.data.id) {
                const formData = new FormData();
                formData.append('file', resume);
                const attachRes = await axios.post('/submit/' + lead.data.id, formData);
                
                if(attachRes){
                    console.log('Success')
                }

                setSubmit(false);
                setSubmitted(true);
            } else {
                console.log('Error: ' + lead.data.errorCode)
                if(lead.data.errorCode === 'DUPLICATES_DETECTED') {
                    setResMessage('An application has already been found')
                } else {
                    setResMessage('Sorry, there seems to have been an issue. Please try again')
                }
                setSubmit(false)
                setSubmitted(true)
            }
        } catch(err) {
            console.log(err)
        }
    }

    return(
        <div className='job'>
            <div className='container'>
                <div className='job-heading'>
                    <h1>{job.role}</h1>
                    <h2>{job.location} | {job.department}</h2>
                </div>
                <div className={job.description ? 'job-resp col-8' : 'd-none'}>
                    <h2>Job Description</h2>
                    <p>{job.description}</p>
                </div>
                <div className={job.resp?.length !== 0 ? 'job-resp col-8' : 'd-none'}>
                    <h2>Responsibilities</h2>
                    <ul>
                        {job.resp?.map((resp) =>
                            <li>{resp}</li>
                        )}
                    </ul>
                </div>
                <div className={job.qualifications?.length !== 0 ? 'job-resp col-8' : 'd-none'}>
                    <h2>Qualifications</h2>
                    <ul>
                        {job.qualifications?.map((resp) =>
                            <li>{resp}</li>
                        )}
                    </ul>
                </div>
                <div className={job.reqs?.length !== 0 ? 'job-resp col-8' : 'd-none'}>
                    <h2>Physical Abilities & Requirements</h2>
                    <ul>
                        {job.reqs?.map((resp) =>
                            <li>{resp}</li>
                        )}
                    </ul>
                </div>
                <div className={job.benefits?.length !== 0 ? 'job-resp col-8' : 'd-none'}>
                    <h2>Our Benefits</h2>
                    <ul>
                        {job.benefits?.map((resp) =>
                            <li>{resp}</li>
                        )}
                    </ul>
                </div>
                <div className='job-resp col-8'>
                    <p>
                        V3 Electric is proud to be an Equal Opportunity Employer and provides equal 
                        employment opportunities to all employees and applicants regardless of race, color,
                        religion, gender, gender identity, age, national origin, disability, parental or 
                        pregnancy status, marriage and civil partnership, sexual orientation, veteran status,
                        or any other characteristic protected by law. Reasonable accommodations will be 
                        made to meet the requirements of the Americans with Disabilities Act and will be 
                        provided as requested by candidates taking part in all aspects of the selection 
                        process.
                        <br/><br/>
                        All your information will be kept confidential according to EEO guidelines.
                    </p>
                </div>
                <div className='job-resp col-8 pb-5'>
                    <h2>Apply</h2>
                    <div className='apply-form'>
                        <div className='pt-2'>
                            <label htmlFor="firstName">First Name *</label>
                            <input className="form-control" disabled={disableInputs} type='text' id="firstName" name="firstName" placeholder="First" onChange={(e) => setFirstName(e.target.value)} />
                            <div className={errorF ? 'error' : 'd-none'}>
                                <p>First Name is required</p>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="lastName">Last Name *</label>
                            <input type='text' className="form-control" disabled={disableInputs} id="lastName" name="lastName" placeholder="Last" onChange={(e) => setLastName(e.target.value)} />
                            <div className={errorL ? 'error' : 'd-none'}>
                                <p>Last Name is required</p>
                            </div>
                        </div>
                        
                        <div>
                            <label htmlFor="email">Email *</label>
                            <input type='text' className="form-control" disabled={disableInputs} name="email" placeholder="email@email.com" onChange={(e) => setEmail(e.target.value)} />
                            <div className={errorE ? 'error' : 'd-none'}>
                                <p>Valid email is required</p>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="phone">Phone *</label>
                            <input className="form-control" disabled={disableInputs} id="phone" name="phone" placeholder="(123) 123-1234" type="text" onChange={(e) => setPhone(e.target.value)} />
                            <div className={errorP ? 'error' : 'd-none'}>
                                <p>Valid phone is required</p>
                            </div>
                        </div>

                        <div>
                            <label htmlFor="resume">Resume *</label>
                            <input className="form-control" disabled={disableInputs} accept="application/pdf,.doc,.docx,application/msword,application/txt" id="resume" name="resume" type="file" onChange={(e) => setResume(e.target.files[0])} />
                            <div className={errorR ? 'error' : 'd-none'}>
                                <p>Resume is required</p>
                            </div>
                        </div>

                        <div className="pt-3">
                            <label htmlFor="optIn">By checking this box you consent to receive notifications & promotional messages related to V3 Electric. *</label>
                            <input type='checkbox' disabled={disableInputs} name="optIn" onChange={(e) => setOptIn(e.target.value)} />
                            <div className={errorO ? 'error' : 'd-none'}>
                                <p>Opt-in for communication is needed</p>
                            </div>
                        </div>

                        <div className='btn-div'>
                            <button type="submit" onClick={errorCheck} disabled={disableInputs}>
                                <div className={submit ? 'd-none' : ''}>
                                    Submit
                                </div>
                                <div className={submit ? '' : 'd-none'}>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </button>
                        </div>
                        <div className={submitted ? '' : 'd-none'}>
                            <p>{resMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobDescription;